<template>
    <div class="painel-page mb-0">
        <div class="painel-page-inner-v2">
            <div class="row">
                <div class="col-md-9 d-flex flex-column justify-content-center">
                    <span>
                        {{ $t('Existe um boleto gerado com as faturas') }} <strong>{{ groupedInstallments }}</strong>
                        {{ $t('deste pedido agrupadas com vencimento em') }} <strong>{{ group.data_venc }}</strong>
                        {{ $t('no valor de') }} <strong>{{ formatCurrency(groupValue()) }}</strong>.
                        {{ $t('Você pode prosseguir com o pagamento ou cancelar o mesmo.') }}
                        {{ $t('Se você cancelar será possível escolher novamente as faturas que deseja pagar.') }}
                    </span>
                </div>
                <div class="col-md-3 d-flex align-items-center">
                    <div v-if="loading" class="btn btn-block btn-primary disabled">
                        <div class="spinner-border spinner-border-sm text-light small" role="status"></div>
                    </div>
                    <div v-else v-on:click="cancelGroup" class="btn btn-block btn-primary mt-1" :class="{disabled: error}"> {{ $t('Cancelar') }} </div>
                </div>
            </div>
            <div v-show="error" class="row">
                <div class="col">
                    <div class="alert alert-danger mb-0 mt-2">{{ $t('Erro ao tentar cancelar o boleto.') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        orderId: {
            type: Number,
            required: true,
        },
        orders: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            error: false,
        }
    },
    methods: {
        async cancelGroup() {
            this.$emit('loading', true)
            try {
                await axios.post(`/api/payment/group/${this.group.id}/cancel`)
                this.$emit('success', this.group)
            } catch (error) {
                this.error = true
            }
            this.$emit('loading', false)
        },
        groupValue() {
            let value = 0
            const invoices = this.groupedInvoices.map(inv => inv.id_boleto)
            for (const order of this.orders) {
                value += order.invoices.reduce((acc, curr) => {
                    return acc + (invoices.includes(curr.id_boleto) ? curr.valor_parcela : 0)
                }, 0)
            }
            return value
        },
        formatCurrency(value) {
            const locale = window.locale.replace('_', '-')
            return new Intl.NumberFormat(locale, { style: 'currency', currency: window.currency, minimumFractionDigits: 2 }).format(value)
        }
    },
    computed: {
        order() {
            return this.orders.find(o => o.id == this.orderId)
        },
        group() {
            const groups = this.orders.reduce((acc, curr) => acc.concat(curr.groups), [])
            return groups.find(g => g.dtkpag_agrupado === 1 && g.del !== 'historico' && g.status !== 'pago')
        },
        groupedInvoices() {
            const ids = this.group.entries.map(e => e.idBoleto)
            return this.order.invoices.filter(i => ids.includes(i.id_boleto))  
        },
        groupedInstallments() {
            const installments = this.groupedInvoices.map(b => b.parcela_numero)
            if (installments.length === 1) {
                return installments[0]
            }
            return `${installments.slice(0, -1).join(', ')} e ${installments[installments.length - 1]}`
        }
    }
}
</script>
